import React from 'react';
import { SearchResults } from '@ratehub/web-components';
import Layout from './Layout';


function SearchPage() {
    return (
        <Layout
            hideBackgroundImage={true}
            isGridDisabled
        >
            <SearchResults />
        </Layout>
    );
}

export default SearchPage;
